import * as React from 'react'

import { palette } from 'main/ui'
import AppFeature from './AppFeature'
import { AppFeaturesContainer } from './AppFeatures.styles'

import { i18nKeyPrefix as PRE } from '../../.'

function AppFeatures() {
  const APP_FEATURES = [
    {
      title: `${PRE}-APP-FEATURES-REAL-TIME-UPDATES-TITLE`,
      description: `${PRE}-APP-FEATURES-REAL-TIME-UPDATES-TXT`,
      imageUrl: 'https://ucarecdn.com/081053c2-82cb-4910-b0df-bfddfa47a5c3/',
      bgColor: palette.lavender2,
    },
    {
      title: `${PRE}-APP-FEATURES-IN-APP-MSG-TITLE`,
      description: `${PRE}-APP-FEATURES-IN-APP-MSG-TXT`,
      imageUrl: 'https://ucarecdn.com/aba78760-7d2c-405c-a58d-c5623b596601/',
      bgColor: palette.rose,
    },
    {
      title: `${PRE}-APP-FEATURES-MOBILE-CHECK-IN-TITLE`,
      description: `${PRE}-APP-FEATURES-MOBILE-CHECK-IN-TXT`,
      imageUrl: 'https://ucarecdn.com/590b0c98-39d7-450d-aec6-b90a783874db/',
      bgColor: palette.goldenrod,
    },
  ]
  return (
    <AppFeaturesContainer>
      {APP_FEATURES.map((item, index) => (
        <AppFeature
          key={index}
          title={item.title}
          description={item.description}
          imageUrl={item.imageUrl}
          bgColor={item.bgColor}
          index={index}
        />
      ))}
    </AppFeaturesContainer>
  )
}

export default AppFeatures
